export const INSTITUTION_ACCOUNT_CATEGORIES = [
  { id: 1, name: "Cross-Ramp India Payin", gateway: "UPI" },
  { id: 2, name: "Cross-Ramp India Payout", gateway: "UPI" },
  { id: 3, name: "Cross-Ramp Brazil Daily Payin", gateway: "PIX" },
  { id: 4, name: "Cross-Ramp Brazil Instant Payin", gateway: "PIX" },
  { id: 5, name: "Cross-Ramp Brazil Payout", gateway: "PIX" },
  { id: 6, name: "Crypto Payment Gateway", gateway: "CPG" },
  { id: 7, name: "Ivy Payin", gateway: "Ivy" },
  { id: 8, name: "Ivy Payout", gateway: "Ivy" },
  { id: 9, name: "PSMD Payin", gateway: "PSMD" },
  { id: 10, name: "PSMD Payout", gateway: "PSMD" },
] as const;

export type InstitutionGateway = "UPI" | "PIX" | "CPG" | "Ivy" | "PSMD";

export const getGatewayForAccountCategory = (
  accountCategoryId: number
): InstitutionGateway | null => {
  if (accountCategoryId === 1 || accountCategoryId === 2) return "UPI";
  if (accountCategoryId >= 3 && accountCategoryId <= 5) return "PIX";
  if (accountCategoryId === 6) return "CPG";
  if (accountCategoryId === 7 || accountCategoryId === 8) return "Ivy";
  if (accountCategoryId === 9 || accountCategoryId === 10) return "PSMD";
  return null;
};

export const isPayinFeeCategory = (accountCategoryId: number) =>
  accountCategoryId === 7 || accountCategoryId === 9;

export const isPayoutFeeCategory = (accountCategoryId: number) =>
  accountCategoryId === 8 || accountCategoryId === 10;

export const usesTemplateId = (accountCategoryId: number) => {
  const gateway = getGatewayForAccountCategory(accountCategoryId);
  return gateway === "UPI" || gateway === "PIX" || gateway === "CPG";
};

export const supportsRampRates = (accountCategoryId: number) => {
  const gateway = getGatewayForAccountCategory(accountCategoryId);
  return gateway === "UPI" || gateway === "PIX";
};

export const supportsNtxpay = (accountCategoryId: number) => {
  return accountCategoryId === 3 || accountCategoryId === 5;
};
